<template>
    <div>
        <input type="hidden" name="_token" :value="csrf">
        <input v-if="this.editing" type="hidden" name="_method" value="PUT">
        <div class="table--custom">
            <div class="single--row single--row-head single--row-head--mini">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-12">
                        <div class="single--row-info">
                            Label
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                        <div class="single--row-info">
                            Level
                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2 col-12">
                        <div class="single--row-info">
                            Evaluation
                        </div>
                    </div>

                    <div class="col-lg-2 col-md-2 col-12">
                        <div class="single--row-info">
                            Status
                        </div>
                    </div>
                </div>
            </div>

            <div class="single--row single--row-input">
                <!--
                <div class="single--row-input-content" v-for="(row,index) in table_data">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-12">
                            <div class="single--row-info">
                                {{row.label}}
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-12">
                            <div class="single--row-info">
                                {{row.level_name}}
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-12">
                            <div class="single--row-info">
                                    <select
                                        :disabled="level_permission['disabled']"
                                        :class="level_permission['classRequired']"
                                        :required="level_permission['required']"
                                        :name="'question['+question_survey_id+']['+row.id+']'"
                                        v-model="colors[row.id]['answer']"
                                        @change="changeLevel($event,row.id)"
                                    >
                                    <option value="null"> ---</option>
                                    <option v-for="option in levels" v-bind:value="option.id">
                                        {{ option.title }}
                                    </option>
                                    <option value="-99">Not evaluable</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-2 col-12">
                            <div class="single--row-info">

                                <p v-html="colors[row.id].delta"></p>

                            </div>
                        </div>
                    </div>

                </div>
                -->
            </div>
        </div>
    </div>
</template>

<style>

</style>

<script>


    export default {

        created() {


        },
        mounted(){
        },
        props: {

            evaluation_chart_id:{
                type     : Number,
                required : true
            },
            question_survey_id:{
                type     : Number,
                required : false
            },
            settings_survey_id:{
                type     : Array,
                required : true
            }


        },
        data () {
            return {


                //default

                action : "",
                editing : true,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        methods: {

        }

    }
</script>

